/**
 * Mã thống kê - thiết lập quy tắc hạch toán đồng thời
 */
export default {
  OtherXDCB: 0,
  IsXDCB: 1,
};
